module.exports = __webpack_public_path__ + "static/media/tv-display.79e0fab3.png";